import React, { useEffect, useState } from "react";
import ButtonActionIcon from "../../BuilderComponents/ButtonActionIcon";
import ChartPreview from "../../BuilderComponents/Preview/ChartPreview";
import DetailsviewPreview from "../../BuilderComponents/Preview/DetailsviewPreview";
import {
  ButtonGroupPreview,
  ButtonPreview,
  DropdownPreview,
  ImagePreview,
  LabelPreview
} from "../../BuilderComponents/Preview/ElementsPreview";
import FormPreview from "../../BuilderComponents/Preview/FormPreview";
import MapPreview from "../../BuilderComponents/Preview/MapPreview";
import RecordviewDesktopPreview from "../../BuilderComponents/Preview/RecordviewDesktopPreview";
import { NestedLayout } from "./DropLayout";
import PivotChartPreview from "../../BuilderComponents/Preview/PivotChartPreview";
import DropdownNavigatePreview from "../../BuilderComponents/Preview/DropdownNavigatePreview";
import { useNavigationContext } from "../../../context/NavigationContext";

const RenderFields = ({
  item,
  layoutData,
  layout,
  setLayout,
  setDragFromOutside,
  dragFromOutside,
  nestedGridData,
  editElement,
  deleteElement,
  copyElement,
  onDrop
}) => {
  const { getSourceAndPath } = useNavigationContext();
  const [elementSource, setElementSource] = useState("");

  useEffect(() => {
    const fetch = async () => {
      try {
        const block = layoutData.current[item.i];
        let tableId = "";
        let tableType = "";

        switch (block.type) {
          case "recordsview":
            tableId = block?.config?.layout?.table_id;
            tableType = block?.table_type;
            break;
          case "detailsview":
          case "chart":
            tableId = block?.config?.table_id;
            tableType = block?.table_type;
            break;
          default:
            break;
        }
        if (!tableType || !tableId) {
          return;
        }
        const { result, error } = await getSourceAndPath(tableType, tableId, "");
        if (error) {
          return;
        }
        if (result) {
          setElementSource(`${block.table_type} > ${result.table_name}`);
        }
      } catch (err) {
        setElementSource("");
      }
    };

    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderElements = (ele) => {
    const {
      type: elementType,
      name: elementName,
      device,
      config,
      content: htmlContent
    } = layoutData.current[ele.i] || {};

    switch (elementType) {
      case "tabview":
      case "section":
        return (
          <NestedLayout
            layout={layout}
            setLayout={setLayout}
            layoutData={layoutData}
            nestedGridData={nestedGridData}
            itemId={item.i}
            dragFromOutside={dragFromOutside}
            setDragFromOutside={setDragFromOutside}
            editElement={editElement}
            onDrop={onDrop}
          />
        );
      case "html":
        return <div dangerouslySetInnerHTML={{ __html: htmlContent }}></div>;
      case "spacer":
        return <div></div>;
      case "image":
        return <ImagePreview config={layoutData.current[ele.i]} />;

      case "label":
        return <LabelPreview config={layoutData.current[ele.i]} />;
      case "dropdown-navigate":
        return <DropdownNavigatePreview config={layoutData.current[ele.i]} />;
      case "button":
        return <ButtonPreview config={layoutData.current[item.i]} />;

      case "button-group":
        return <ButtonGroupPreview config={layoutData.current[item.i]} />;
      case "dropdown":
        return <DropdownPreview config={layoutData.current[item.i]} />;

      case "recordsview":
        switch (device) {
          case "desktop":
            return <RecordviewDesktopPreview data={layoutData.current[ele.i]} />;
          case "mobile":
            return <DetailsviewPreview detailviewConfig={config?.layout?.catalog?.elements} />;
          default:
            return <h2>No block</h2>;
        }
      case "detailsview":
        switch (device) {
          case "desktop":
            return <DetailsviewPreview detailviewConfig={config?.elements} />;
          case "mobile":
            return <DetailsviewPreview detailviewConfig={config?.elements} />;
          default:
            return <h2>No block</h2>;
        }
      case "chart":
        return <ChartPreview data={layoutData.current[ele.i]} />;
      case "mapsview":
        return <MapPreview />;
      case "publicform":
        return <FormPreview data={layoutData.current[ele.i]} />;
      case "pivotcharts":
        return <PivotChartPreview data={layoutData.current[ele.i]} />;
      default:
        return <div>{elementName}</div>;
    }
  };

  return (
    <div className="dev" key={item.i}>
      <div className="space_between align_center">
        <div className="screen_element_btn align_center space_between">
          {elementSource ? (
            <div className="border_full bg_light py_1 px_2 text_wrap_nowrap">{elementSource}</div>
          ) : (
            <div></div>
          )}
          <div className="d_flex align_center space_between gap_1">
            {layoutData.current[item.i]?.device && (
              <div className="scree_block_info">
                <strong>{layoutData.current[item.i].name}</strong>
              </div>
            )}
            <ButtonActionIcon type="edit" size="sm" onClick={() => editElement(item.i)} />
            {["html", "spacer", "image", "label", "dropdown-navigate", "button", "button-group", "form"].includes(
              layoutData.current[item.i]?.type
            ) && <ButtonActionIcon type="content_copy" size="sm" onClick={() => copyElement(item.i)} />}
            <ButtonActionIcon type="delete" size="sm" onClick={() => deleteElement(item.i)} />
          </div>
        </div>
      </div>
      {renderElements(item)}
    </div>
  );
};

export default RenderFields;
